/**
 * Created by andrey on 08.08.2025
 */

cc.RepeatForever = function (action) {
    cc.ActionInterval.prototype.constructor.call(this);

    if (!action) {
        throw new Error("cc.RepeatForever.initWithAction(): action must be non null");
    }

    this._innerAction = action;
};

cc.RepeatForever.prototype = Object.assign(Object.create(cc.ActionInterval.prototype), {
    constructor: cc.RepeatForever,

    startWithTarget: function (target) {
        cc.ActionInterval.prototype.startWithTarget.call(this, target);
        this._innerAction.startWithTarget(target);
    },

    step: function (dt) {
        const locInnerAction = this._innerAction;
        locInnerAction.step(dt);
        if (locInnerAction.isDone()) {
            // var diff = locInnerAction.getElapsed() - locInnerAction._duration;
            locInnerAction.startWithTarget(this.target);
            // to prevent jerk. issue #390 ,1247
            // this._innerAction.step(0);
            // this._innerAction.step(diff);
            locInnerAction.step(locInnerAction.getElapsed() - locInnerAction._duration);
        }
    },

    isDone: function () {
        return false;
    },

    canFinalize: function () {
        return Boolean(this._finalize);
    },

    _autoFinalize: function () {}
});

cc.repeatForever = (action) => new cc.RepeatForever(action);
